export const DISABLED_ROLE_ROLES_OWNER = 'roles/owner';
export default [DISABLED_ROLE_ROLES_OWNER];
